<div class="box">
  @if (!!title()) {
    <h2>{{ title() }}</h2>
  }
  <table>
    <tr>
      <td>Name:</td>
      <td>{{ file().filename}}</td>
    </tr>
    <tr>
      <td>Content type:</td>
      <td><span [attr.style]="hiliteContentType() ? 'background-color: ' + color() +';' : null">{{ file().contentType}}</span></td>
    </tr>
    <tr>
      <td>Encoding:</td>
      <td><span [attr.style]="hiliteEncoding() ? 'background-color: ' + color() +';' : null">{{ file().encoding}}</span></td>
    </tr>
    <tr>
      <td>Byte-order-mark:</td>
      <td><span [attr.style]="hiliteBomPresent() ? 'background-color: ' + color() +';' : null">{{ file().bomPresent ? 'Present' : 'Not present' }}</span>
    </td>
  </tr>
  <tr>
    <td>Size:</td>
    <td><span [attr.style]="hiliteContentLength() ? 'background-color: ' + color() +';' : null">{{ file().size }} bytes</span></td>
  </tr>
</table>
</div>
